import { get } from "./api";

export async function getSimilarItems(lotId, filters) {
  const res = await get(`application/community/recommendation/lot/${lotId}`, filters);
  return res.data;
}
